import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { settingsQueryOptions } from '@utils/queryOptions';
import BuyCredits from './BuyCredits';
import { useState } from 'react';
import CurrentPlan from './CurrentPlan';
import PaymentMethod from './PaymentMethod';

const BillingSettings = () => {
    const [buyCreditsDialog, setBuyCreditsDialog] = useState(false);
    const { data: settings } = useSuspenseQuery(settingsQueryOptions());

    return (
        <Stack spacing={2}>
            <CurrentPlan emailPlan={settings.email_plan} />
            <PaymentMethod paymentMethod={settings.payment_method} />
            <BuyCredits
                open={buyCreditsDialog}
                onClose={() => setBuyCreditsDialog(false)}
            />
        </Stack>
    );
};

export default BillingSettings;
